import { useTranslation } from "react-i18next";
import SearchInput from "../search-input";
import { useHistoryFilters } from "@/features/history/hooks/useHistoryFilters";
import HistoryInlineFilters from "@/features/history/components/history-inline-filters";
import HistoryFilterComponent from "@/features/history/components/history-filter-component";

const HistoryPageHeader = () => {
  const { t } = useTranslation();
  const [filters, setFilters] = useHistoryFilters();

  return (
    <div className="flex-1 flex items-center justify-between w-full">
      <h1 className="lg:text-lg">{t("titles.dashboard.history")}</h1>
      <div className="flex items-center gap-2 flex-1 justify-end">
        <SearchInput
          value={filters.search ?? ""}
          onChange={(v) => setFilters({ search: v || null })}
          placeholder={t("modules.history.keys.search_placeholder")}
          className="max-w-72 hidden lg:flex"
        />
        <div className="hidden lg:block xl:hidden">
          <HistoryFilterComponent />
        </div>
        <div className="hidden xl:flex items-center gap-2">
          <HistoryInlineFilters />
        </div>
      </div>
    </div>
  );
};

export default HistoryPageHeader;
